import { createSignal } from "solid-js";
export const [fps, setFPS] = createSignal();
export const [pps, setPPS] = createSignal();
export const [lps, setLPS] = createSignal();
